export const PROVIDERS_FILTER_GROUP_NAME = 'Providers';
export const FILTER_BLANKS_KEY = 'filterBlanks';
export const FILTER_NON_BLANKS_KEY = 'filterNonBlanks';
export const FILTER_EXTRACTED_KEY = 'filterExtracted';
export const FILTER_DUPLICATES_KEY = 'filterDuplicates';
